import { render, staticRenderFns } from "./VxDynamicForm.vue?vue&type=template&id=86e881c0&scoped=true"
import script from "./VxDynamicForm.vue?vue&type=script&lang=js"
export * from "./VxDynamicForm.vue?vue&type=script&lang=js"
import style0 from "./VxDynamicForm.vue?vue&type=style&index=0&id=86e881c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e881c0",
  null
  
)

export default component.exports